import { confirm } from 'owa-confirm-dialog';
import folderStore, { SourceWellKnownFolderType } from 'owa-folders';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import strings from 'owa-strings/owa-mail-strings';

/**
 * Moving and deleting items to/from Starred and Important folders should be blocked. We will show following message prompt to the user if these actions are performed on the client -
 * - Move/Delete from Important: “You can’t move or delete items from this folder”
 * - Move/Delete to Important:" You can’t move items to this folder"
 * - Move/Delete from Starred: “To remove an item from this folder, unflag it”
 * - Move to Starred: “To move an item to this folder, flag it”
 * @param sourceFolderId - Source folder id
 * @param destinationFolderId - Destination folder id
 * @returns true if the action was blocked, false otherwise
 */
export default function handleBlockActionForShadowMailbox(
    sourceFolderId: string,
    destinationFolderId: string
): boolean {
    if (!getUserConfiguration().SessionSettings.IsShadowMailbox) {
        return false;
    }

    let message;
    const sourceFolder = folderStore.folderTable.get(sourceFolderId);
    const destinationFolder = folderStore.folderTable.get(destinationFolderId);
    const sourceFolderType = sourceFolder.sourceWellKnownFolderType;

    if (sourceFolderType == SourceWellKnownFolderType.Important) {
        message = strings.blockActionFromImportantFolder;
    } else if (sourceFolderType == SourceWellKnownFolderType.Starred) {
        message = strings.blockMoveDeleteFromStarredFolder;
    } else if (destinationFolder != null) {
        const destinationFolderType = destinationFolder.sourceWellKnownFolderType;

        if (destinationFolderType == SourceWellKnownFolderType.Important) {
            message = strings.blockActionToImportantFolder;
        } else if (destinationFolderType == SourceWellKnownFolderType.Starred) {
            message = strings.blockMoveToStarredFolder;
        }
    }

    if (message != undefined) {
        confirm('', message, false, {
            hideCancelButton: true,
        });
        return true;
    }

    return false;
}
